// extracted by mini-css-extract-plugin
module.exports = {"alert":"index_alert_25JhE","title":"index_title_1t5Dh","type_error":"index_type_error_1MR1Z","type_success":"index_type_success_ObBvF","type_warning":"index_type_warning_1kvVK"};